<template>
  <div>
    <div class="filter-bar">
      <span @click="selectYear">
        年份 {{ year }}
        <i class="caret"></i>
      </span>
      <span>
        {{ querytype }}
        <i class="caret"></i>
        <select
          class="filter-item__select"
          v-model="querytype"
          @change="searchMonth"
        >
          <option :value="'全部'">全部</option>
          <option :value="'工作中心'">工作中心</option>
          <option :value="'物料'">物料</option>
        </select>
      </span>
    </div>

    <div class="canvas-box">
      <canvas id="myChart" class="myChart"></canvas>
    </div>

    <div class="list-container" v-if="querytype == '全部' && result.monthitems">
      <div class="list-fixed">
        <p class="list-box-col__title">月份</p>
        <p
          class="list-box-col__content"
          v-for="item in result.monthitems"
          :key="item.text"
        >
          {{ item.text }}
        </p>
        <p class="list-box-col__content">本年累计</p>
      </div>
      <div class="list-scroll">
        <div class="list-scroll-wrap">
          <div
            class="list-box-col"
            @click="initChart(deal2(result.details[0]))"
          >
            <p class="list-box-col__title">损耗金额</p>
            <p
              class="list-box-col__content"
              style="color: #2eadf5"
              v-for="item in result.monthitems"
              :key="item.text"
            >
              {{ numberFormat(item.amount, "#,##0.##") || 0 }}
            </p>
            <p class="list-box-col__content" style="color: #2eadf5">
              {{ numberFormat(result.details[0].amount, "#,##0.##") || 0 }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="list-cells" v-if="querytype != '全部' && result.monthitems">
      <div
        class="list-cell"
        v-for="(item, index) in result.details"
        :key="index"
      >
        <div class="list-cell__main" @click="open(index)">
          <div class="list-cell__index">
            <span>{{ index + 1 }}</span>
          </div>
          <div class="list-cell__content">
            <p v-if="querytype == '工作中心'">{{ item.ma_wcname }}</p>
            <p v-if="querytype == '物料'">
              {{ item.mm_prodcode }}{{ item.pr_detail }}
            </p>
            <p>{{ numberFormat(item.amount, "#,##0.##") || 0 }}</p>
          </div>
          <div class="list-cell__toggle">
            <span v-if="opened == index"
              ><i class="iconfont icon-shang"></i
            ></span>
            <span v-else><i class="iconfont icon-xia"></i></span>
          </div>
        </div>
        <div class="weui-cells" v-if="opened == index">
          <div class="weui-cell gray" v-for="month in 12" :key="month">
            <div class="weui-cell__bd">{{ month }}月</div>
            <div class="weui-cell__ft" style="font-size: 12px">
              {{ numberFormat(item["amount" + month], "#,##0.##") || 0 }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import SearchBar from "@/components/SearchBar.vue";
// import ProductField from "@/components/field/ProductField.vue";
// import F2 from '@antv/f2'
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  data() {
    return {
      result: {},
      year: new Date().getFullYear(),
      querytype: "全部",
      querytypeObj: {
        全部: "detail",
        工作中心: "workcenter",
        物料: "prod",
      },
      opened: -1,
      chart: null,
    };
  },
  mounted() {
    this.searchMonth();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    searchMonth() {
      let me = this,
        year = me.year,
        querytype = me.querytypeObj[me.querytype];

      let params = {
        year,
        querytype,
      };

      me.$ajax({
        url: "/api/make/report/productionLossOsMonth",
        params,
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          if (res.data.monthitems) {
            me.initChart(me.deal(me.result.monthitems));
          } else {
            if (querytype == "detail") {
              me.initChart(me.deal2(me.result.details[0]));
            }
          }
        }
      });
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.monthitems));
      }
    },
    initChart(data) {
      var chart = this.chart;
      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });
      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 12 : 6,
          formatter: (i) =>
            i > -1 && i < 12
              ? [
                  "01月",
                  "02月",
                  "03月",
                  "04月",
                  "05月",
                  "06月",
                  "07月",
                  "08月",
                  "09月",
                  "10月",
                  "11月",
                  "12月",
                ][i]
              : null,
        },
      });

      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "损耗金额") {
            return "#2eadf5";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05, // 设置分组间柱子的间距
        });
      if (window.innerWidth < window.innerHeight) {
        // 定义进度条
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      }
      chart.interaction("pan");
      chart.render();
    },
    open(index) {
      if (index != this.opened)
        this.initChart(this.deal2(this.result.details[index]));

      this.opened = index == this.opened ? -1 : index;
    },
    deal(data) {
      if (!data) return;

      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: "损耗金额", value: 0 },
        { index: 12, type: "损耗金额", value: 0 },
      ];
      data.forEach((item, i) => {
        arr.push({
          text: item.text,
          type: "损耗金额",
          index: i,
          value: item.amount || 0,
        });
      });
      const l = arr.length / 3;
      if (l < 12) {
        for (let i = l; i < 12; i++) {
          arr.push({
            index: i,
            text: textArr[i],
            type: "损耗金额",
            value: 0,
          });
        }
      }
      return arr;
    },
    deal2(data) {
      if (!data) return;
      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: data.text, value: 0 },
        { index: 12, type: data.text, value: 0 },
      ];
      for (let i = 0; i < 12; i++) {
        arr.push({
          index: i,
          text: textArr[i],
          type: data.text,
          value: data["amount" + (i + 1)] || 0,
        });
      }
      return arr;
    },
    selectYear() {
      var me = this,
        year = new Date().getFullYear(),
        years = [];
      for (let i = year - 20; i <= year; i++) {
        years.push({
          value: i,
          label: i + "年",
        });
      }
      me.$weui.picker(years, {
        title: "选择年份",
        defaultValue: [year],
        onConfirm: function (r) {
          me.year = r[0].value;
          me.searchMonth();
        },
      });
    },
  },
};
</script>

<style scoped>
.canvas-box {
  overflow-x: scroll;
  background: var(--weui-BG);
}

.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}

.list-container {
  text-align: center;
  line-height: 40px;
  background: var(--weui-BG);
  display: flex;
}
.list-scroll {
  flex-grow: 1;
  overflow-y: scroll;
}
.list-scroll-wrap {
  display: flex;
  justify-content: space-around;
}
.list-box-col:active {
  background: #e0e0e0;
}
.list-box-col__title {
  font-weight: bold;
}
.list-box-col__content {
  font-size: small;
  color: var(--weui-FG-0);
}

.list-cells {
  margin-top: 5px;
  background: var(--weui-BG);
}
.list-cell {
  background-color: #fff;
}
.list-cell__main {
  display: flex;
  padding: 10px 0;
}
.list-cell__index {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-cell__index span {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  background-color: #c0c0c0;
}
.list-cell__content {
  flex: 1;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #8b8b8b;

  display: flex;
  justify-content: space-between;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__toggle {
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  padding: 0 20px;
}
.gray {
  /* max-height: 300px;
  overflow-y: auto; */
  background: #f4f4f4;
}
@media screen and (min-width: 500px) {
  .filter-bar {
    padding: 6px 0 2px 0;
  }
  .list-scroll-wrap {
    width: 100%;
  }
  .list-container {
    line-height: 25px;
  }
}
</style>